const LABELS = {
	location: 'Ort',
	radius: 'Umkreis (km)',
	states: 'Bundesländer',
	postalCodes: 'PLZ',
	postalCode: 'PLZ',
	industrySearchTerms: 'Branchenbegriffe',
	industryCodes: 'WZ-Codes',
	industryCategories: 'Branchenkategorien',
	searchKeywords: 'Suchbegriffe',
	excludeKeywords: 'Ausschlüsse',
	legalForm: 'Rechtsform',
	companyStatus: 'Firmenstatus',
	companyKinds: 'Firmenart',
	contactChannel: 'Kontaktkanal',
	employeesMin: 'Mitarbeiter ab',
	employeesMax: 'Mitarbeiter bis',
	revenueMin: 'Umsatz ab (€)',
	revenueMax: 'Umsatz bis (€)',
	earningsMin: 'Gewinn ab (€)',
	earningsMax: 'Gewinn bis (€)',
	eventType: 'Ereignis',
	eventDateFrom: 'Ereignis ab',
	eventDateTo: 'Ereignis bis',
	'fulltext.terms': 'Volltext',
	'fulltext.mode': 'Volltext-Modus',
	'website.customerTypes': 'Website: Kundentypen',
	'website.businessModel': 'Website: Geschäftsmodell',
	'website.offerings': 'Website: Angebote',
	'website.specializations': 'Website: Spezialisierungen',
	'website.serviceArea': 'Website: Einzugsgebiet',
	'website.tech': 'Website: Technik',
	'hiring.active': 'Stellen ausgeschrieben',
	'hiring.occupations': 'Gesuchte Berufe',
	'management.ownerLedOnly': 'Nur inhabergeführt',
	'management.ceoCountMin': 'Geschäftsführer ab',
	'management.ceoCountMax': 'Geschäftsführer bis',
	discoverySource: 'Quelle',
	loose: 'Lockere Suche',
	op: 'Operation',
	notes: 'Hinweise an die Prüfung',
	limit: 'Höchstens',
	searchTerms: 'Suchbegriffe',
	ratingMin: 'Bewertung ab',
	roles: 'Rollen',
	maxContactsPerCompany: 'Kontakte je Firma',
	maxPerCompany: 'Kontakte je Firma',
	totalLimit: 'Kontakte gesamt',
	maxCompanies: 'Firmen höchstens',
	name: 'Name',
	'selection.limit': 'Stückzahl',
	'selection.ranking': 'Reihenfolge',
	recipientMode: 'Empfängerart',
	rolePriority: 'Rollenpriorität',
	reachableBy: 'Erreichbar per',
	scope: 'Bereich',
	titleKeywords: 'Titel-Stichworte',
	managementLevels: 'Management-Ebenen',
	departments: 'Abteilungen',
	terms: 'Begriffe',
	page: 'Seite',
	pageSize: 'Je Seite',
	total: 'Treffer',
	countKind: 'Zählung',
	stored: 'Gespeicherte Kandidaten',
	warnings: 'Hinweise',
	resolvedIndustryCodes: 'Aufgelöste WZ-Codes',
	sampleCount: 'Stichprobe',
	checked: 'Geprüft',
	fit: 'Passend',
	unfit: 'Unpassend',
	unknown: 'Unklar',
	candidates: 'Zu prüfen',
	stale: 'Veraltet (Kriterien geändert)',
	criteriaVersion: 'Kriterienversion',
	requested: 'Angefordert',
	created: 'Neu übernommen',
	charged: 'Credits abgebucht',
	skippedExisting: 'Bereits vorhanden',
	'bySource.pool': 'Aus dem Pool',
	'bySource.maps': 'Aus externer Suche',
	limitedByCredits: 'Durch Guthaben begrenzt',
	remainingMandate: 'Mandat danach frei',
	reserved: 'Reserviert',
	companies: 'Firmen',
	companiesCount: 'Firmen',
	n: 'Bestellt',
	maxTotalChargeUsd: 'Kostendeckel (USD)',
	captured: 'Abgerechnet',
	added: 'In die Liste übernommen',
	poolCoverage: 'Im Pool vorhanden',
	poolFresh: 'Davon aktuell',
	'externalRun.allowed': 'Externe Suche erlaubt',
	'externalRun.nationwide': 'Deutschlandweit',
	'externalRun.nationwideAllowed': 'Deutschlandweit erlaubt',
	'externalRun.gap': 'Lücke',
	codes: 'Codes',
	companyIds: 'Firmen',
	'stages.prefiltered': 'Ohne Modell entschieden',
	'stages.bulk': 'Im Bündel geprüft',
	'stages.single': 'Einzeln geprüft',
};

const VALUE_LABELS = {
	countKind: { exact: 'exakt', upper_bound: 'Obergrenze', estimate: 'Schätzung' },
	op: { union: 'Vereinigung', intersect: 'Schnitt', subtract: 'Differenz' },
	'selection.ranking': { fit_score: 'Passung', completeness: 'Vollständigkeit', reachability: 'Erreichbarkeit' },
	'fulltext.mode': { all: 'alle Begriffe', any: 'ein Begriff' },
};

// Technical identifiers, raw echoes and per-company data: before a purchase the UI shows only
// aggregates of a run, never anything tied to an identifiable company outside the preview.
const HIDDEN = new Set([
	'perCompany',
	'sample',
	'sets',
	'candidateSetId',
	'companies',
	'byCompany',
	'companyId',
	'matched',
	'operationId',
	'status',
	'jobId',
	'holdId',
	'apifyRunId',
	'datasetId',
	'startIntentAt',
	'offset',
	'prospectQueryId',
	'contactListId',
	'poolCompanyIds',
	'topFit',
	'error',
	'message',
	'problems',
	'retryable',
]);

// Arrays of company ids are shown as a count: the ids mean nothing to the user and the names
// are not shown before the purchase.
const ID_LISTS = new Set(['companyIds']);

const formatValue = (path, value) => {
	if (value === null || value === undefined || value === '') return null;
	const mapped = VALUE_LABELS[path]?.[value];
	if (mapped) return mapped;
	if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';
	if (typeof value === 'number') return value.toLocaleString('de-DE');
	if (Array.isArray(value)) {
		if (value.length === 0) return null;
		return value.map((item) => (typeof item === 'object' ? JSON.stringify(item) : String(item))).join(', ');
	}
	return String(value);
};

const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

const STAGE_LABELS = {
	base: 'Grundmenge',
	status: 'Status aktiv',
	standort: 'Standort',
	branche: 'Branche',
	zielgruppe: 'Zielgruppe',
	groesse: 'Größe',
	finanzen: 'Finanzen',
	volltext: 'Volltext',
	website: 'Website-Profil',
	rechtsform: 'Rechtsform',
	ereignis: 'Ereignis',
	firmenart: 'Firmenart',
};

const labelFor = (path, key) => LABELS[path] ?? LABELS[key] ?? key;

// Count stages come as [{ key, count, estimate? }]: one row per stage in the given order.
const isStageList = (value) =>
	Array.isArray(value) && value.length > 0 && value.every((item) => isPlainObject(item) && 'count' in item);

const stageRows = (path, stages) =>
	stages.map((stage) => {
		const count = formatValue(path, stage.count) ?? '0';
		return {
			label: `Stufe ${STAGE_LABELS[stage.key] ?? stage.key ?? ''}`.trim(),
			value: stage.estimate ? `ca. ${count}` : count,
		};
	});

const reasonRows = (path, reasons) =>
	Object.entries(reasons).map(([category, count]) => ({ label: category, value: formatValue(path, count) }));

// Nested groups whose children may render; any other object is left out whole.
const GROUPS = new Set([
	'fulltext',
	'website',
	'hiring',
	'management',
	'selection',
	'bySource',
	'externalRun',
	'stages',
]);

const isKnown = (path, key) => Boolean(LABELS[path] ?? LABELS[key]);

/**
 * One entry of a tool's input or result. Only field names on the allowlist above become rows:
 * the model's input and the tool's output may carry keys the server could not foresee, and a
 * key is as much text as a value.
 */
function addEntry(rows, key, raw, path) {
	if (HIDDEN.has(key)) return;
	if (ID_LISTS.has(key) && Array.isArray(raw)) {
		rows.push({ label: labelFor(path, key), value: String(raw.length) });
	} else if (key === 'stages' && isStageList(raw)) {
		rows.push(...stageRows(path, raw));
	} else if (key === 'reasons' && isPlainObject(raw)) {
		rows.push(...reasonRows(path, raw));
	} else if (isPlainObject(raw)) {
		if (GROUPS.has(key)) collectRows(rows, raw, path);
	} else if (Array.isArray(raw) && raw.some(isPlainObject)) {
		// Lists of objects are records, not counts; they stay out of the card.
	} else if (isKnown(path, key)) {
		const value = formatValue(path, raw);
		if (value !== null) rows.push({ label: labelFor(path, key), value });
	}
}

function collectRows(rows, object, prefix) {
	for (const [key, raw] of Object.entries(object ?? {})) {
		addEntry(rows, key, raw, prefix ? `${prefix}.${key}` : key);
	}
}

/**
 * Flattens a tool's input or result into label/value rows for the tool card: only known keys
 * (German labels) become rows, known groups are flattened to `a.b`, id lists become counts,
 * everything unknown — including keys the model invented — is left out.
 *
 * @param {object|null|undefined} data
 * @returns {Array<{label: string, value: string}>}
 */
export function toolDataRows(data) {
	const rows = [];
	collectRows(rows, data, '');
	return rows;
}
